/* GAP configurator add-on, loaded by a Custom Liquid section in templates/page.gap-configurator.json.
   (1) Photo file type. JPG, PNG and WebP go straight through. HEIC/HEIF (iPhone photos copied to a computer) is turned into
   a full-size JPG in the browser with heic2any (loaded from jsDelivr only when needed) and then handed to the normal
   upload, so the preview works everywhere and the print file is a JPG. Camera RAW is handled before this by
   gap-configurator-raw.js. Anything else (TIFF, PDF ...) is stopped with a clear message instead of being previewed and
   failing at upload. Listens on document in the capture phase, so it runs before gap-configurator.js sees the file. On
   iPhone/iPad HEIC and RAW are left out of accept, so iOS hands over a JPEG itself (faster than converting here).
   (2) Size cards. Products that list both 20x30 and 30x20 variants show the same size twice once turned to the chosen
   orientation: later copies are hidden (the selected one is kept), the cards are sorted by area, and more than five
   cards wrap onto rows of five instead of scrolling sideways.
   (3) Keyboard. While a custom size field has focus the preview and the tab row are hidden and the configurator is
   fitted to the visible viewport, so the Width/Height fields stay above the phone keyboard.
   (4) cm | inch switch in the size sheet header. Only the size cards change (whole inches, drawn from data-in by CSS);
   the custom fields stay in cm with an inch hint, and the summary, cart and production stay in cm. Choice is remembered.
   (5) Border placement, (6) On wall nudge, (7) Done cue: see below. */
(function () {
  var OK_TYPE = /^image\/(jpeg|pjpeg|png|webp)$/i, OK_EXT = /\.(jpe?g|png|webp)$/i;
  var HEIC_TYPE = /^image\/hei[cf](-sequence)?$/i, HEIC_EXT = /\.hei[cf]$/i;
  var IOS = /iP(hone|ad|od)/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  var ACCEPT = IOS ? 'image/jpeg,image/png,image/webp,.jpg,.jpeg,.png,.webp'
    : 'image/jpeg,image/png,image/webp,image/heic,image/heif,.jpg,.jpeg,.png,.webp,.heic,.heif'
      + ',.cr2,.cr3,.crw,.nef,.nrw,.arw,.srf,.sr2,.dng,.raf,.orf,.rw2,.pef,.srw,.3fr,.iiq,.erf,.kdc,.mrw,.x3f';
  var HEIC_LIB = 'https://cdn.jsdelivr.net/npm/heic2any@0.0.4/dist/heic2any.min.js';
  var SEL_FILE = '[data-gapcfg] [data-file]';
  function q(s) { return document.querySelector(s); }
  function say(msg, err) {
    var st = q('[data-gapcfg] [data-status]');
    if (!st) { if (err) window.alert(msg); return; }
    st.textContent = msg; st.classList.toggle('is-error', !!err); st.hidden = false;
  }
  function setAccept() { var f = q(SEL_FILE); if (f && f.getAttribute('accept') !== ACCEPT) f.setAttribute('accept', ACCEPT); }
  setAccept();
  document.addEventListener('click', setAccept, true);

  var lib = null;
  function loadLib() {
    if (lib) return lib;
    lib = new Promise(function (ok, fail) {
      if (window.heic2any) return ok(window.heic2any);
      var s = document.createElement('script'); s.src = HEIC_LIB; s.async = true;
      s.onload = function () { window.heic2any ? ok(window.heic2any) : fail(new Error('no heic2any')); };
      s.onerror = function () { lib = null; fail(new Error('load failed')); };
      document.head.appendChild(s);
    });
    return lib;
  }
  function heicToJpg(el, f) {
    say('Converting your iPhone photo (HEIC) to JPG… this can take a few seconds.');
    loadLib().then(function (h) { return h({ blob: f, toType: 'image/jpeg', quality: 0.95 }); }).then(function (out) {
      var blob = Array.isArray(out) ? out[0] : out;
      var jpg = new File([blob], f.name.replace(HEIC_EXT, '') + '.jpg', { type: 'image/jpeg', lastModified: Date.now() });
      var dt = new DataTransfer(); dt.items.add(jpg);
      el.files = dt.files;
      el.dispatchEvent(new Event('change', { bubbles: true }));
    }).catch(function () {
      say('We could not convert this HEIC photo. Please save it as a JPG and try again, or WhatsApp us on 07445 250359.', true);
    });
  }
  document.addEventListener('change', function (e) {
    var el = e.target;
    if (!el || !el.matches || !el.matches(SEL_FILE)) return;
    var f = el.files && el.files[0];
    if (!f || OK_TYPE.test(f.type) || (!f.type && OK_EXT.test(f.name))) return;
    e.stopImmediatePropagation();
    if (HEIC_TYPE.test(f.type) || HEIC_EXT.test(f.name)) { heicToJpg(el, f); return; }
    el.value = '';
    var ext = (/\.([a-z0-9]{1,5})$/i.exec(f.name) || [])[1];
    say((ext ? '.' + ext.toUpperCase() + ' files' : 'This file type') + ' can’t be used. Please choose a JPG, PNG, WebP, HEIC or camera RAW photo. For TIFF and other files, save a JPG copy first, or WhatsApp us on 07445 250359.', true);
  }, true);

  /* (2) size cards, (3) keyboard, (4) units */
  var css = document.createElement('style');
  css.textContent = '.gapcfg__cards[data-fitrow][data-many]{grid-auto-flow:row!important;grid-auto-columns:auto!important;grid-template-columns:repeat(5,minmax(0,1fr))!important}'
    + 'html.gapcfg-kb [data-gapcfg] [data-stage],html.gapcfg-kb [data-gapcfg] .gapcfg__tabs{display:none!important}'
    + 'html.gapcfg-kb [data-gapcfg] [data-dock]{flex:1 1 auto!important;min-height:0!important}'
    + 'html.gapcfg-kb [data-gapcfg] [data-sheet]{flex:1 1 auto!important;height:auto!important;max-height:none!important;overflow-y:auto!important}'
    + '.gapcfg__unit{display:inline-flex;margin:0 14px 0 auto;border:1.5px solid #ddd;border-radius:999px;overflow:hidden;flex:none}'
    + '.gapcfg__unit[hidden]{display:none}'
    + '.gapcfg__unit button{appearance:none;border:0;background:#fff;color:#333;font-family:inherit;font-weight:600;font-size:13px;line-height:1;padding:6px 12px;cursor:pointer}'
    + '.gapcfg__unit button[aria-pressed=true]{background:#C8401A;color:#fff}'
    + 'html.gapcfg-in .gapcfg__card b[data-in]{font-size:0!important}'
    + 'html.gapcfg-in .gapcfg__card b[data-in]::before{content:attr(data-in);font-size:var(--gin-fs,15px)}'
    + '.gapcfg__inhint{font-size:13px;opacity:.7;margin-top:2px}html:not(.gapcfg-in) .gapcfg__inhint{display:none}';
  document.head.appendChild(css);
  var SIZE = /(\d+(?:\.\d+)?)\s*[×x]\s*(\d+(?:\.\d+)?)\s*cm/i, busy = false;
  function inch(cm) { return Math.round(cm / 2.54); }
  function tidy() {
    var cards = q('[data-gapcfg] [data-cards]');
    if (!cards || busy) return;
    busy = true;
    var list = [].slice.call(cards.children), seen = {}, n = 0;
    list.forEach(function (c) { var m = SIZE.exec(c.textContent); if (m && c.getAttribute('aria-checked') === 'true') seen[m[1] + 'x' + m[2]] = c; });
    list.forEach(function (c) {
      var m = SIZE.exec(c.textContent);
      if (!m || c.textContent.indexOf('Custom size') === 0) return;
      var k = m[1] + 'x' + m[2], dup = seen[k] && seen[k] !== c;
      if (!seen[k]) seen[k] = c;
      var d = dup ? 'none' : '';
      if (c.style.display !== d) c.style.display = d;
      var o = String(Math.round(+m[1] * +m[2]));
      if (c.style.order !== o) c.style.order = o;
      if (!dup) n++;
      var b = c.querySelector('b');
      if (b && SIZE.test(b.textContent)) {
        var di = inch(+m[1]) + '×' + inch(+m[2]) + '″';
        if (b.getAttribute('data-in') !== di) b.setAttribute('data-in', di);
        var fs = getComputedStyle(b).fontSize;
        if (fs !== '0px' && b.style.getPropertyValue('--gin-fs') !== fs) b.style.setProperty('--gin-fs', fs);
      }
    });
    var many = n > 5;
    if (cards.hasAttribute('data-many') !== many) { if (many) cards.setAttribute('data-many', ''); else cards.removeAttribute('data-many'); }
    busy = false;
  }
  var root = document.documentElement, unit = 'cm';
  try { unit = localStorage.getItem('gapUnit') === 'in' ? 'in' : 'cm'; } catch (e) {}
  function setUnit(u) {
    unit = u; root.classList.toggle('gapcfg-in', u === 'in');
    try { localStorage.setItem('gapUnit', u); } catch (e) {}
    var t = q('.gapcfg__unit');
    if (t) [].forEach.call(t.children, function (x) { x.setAttribute('aria-pressed', String(x.getAttribute('data-u') === u)); });
    hint();
  }
  function hint() {
    var c = q('[data-gapcfg] [data-custom]'), w = q('[data-gapcfg] [data-cw]'), h = q('[data-gapcfg] [data-ch]');
    if (!c || !w || !h) return;
    var el = c.querySelector('.gapcfg__inhint');
    if (!el) { el = document.createElement('div'); el.className = 'gapcfg__inhint'; c.querySelector('.gapcfg__crow').insertAdjacentElement('afterend', el); }
    var a = parseFloat(w.value), b = parseFloat(h.value);
    el.textContent = a > 0 && b > 0 ? '≈ ' + (a / 2.54).toFixed(1) + ' × ' + (b / 2.54).toFixed(1) + ' in' : '1 in = 2.54 cm';
  }
  document.addEventListener('input', function (e) { if (e.target.matches && e.target.matches('[data-gapcfg] [data-cw],[data-gapcfg] [data-ch]')) hint(); });
  function unitSwitch() {
    var head = q('[data-gapcfg] .gapcfg__sheethead'), title = q('[data-gapcfg] [data-sheettitle]');
    if (!head || !title) return;
    var t = head.querySelector('.gapcfg__unit');
    if (!t) {
      t = document.createElement('div'); t.className = 'gapcfg__unit'; t.setAttribute('role', 'group'); t.setAttribute('aria-label', 'Units');
      t.innerHTML = '<button type="button" data-u="cm">cm</button><button type="button" data-u="in">inch</button>';
      t.addEventListener('click', function (e) { var u = e.target.getAttribute('data-u'); if (u) setUnit(u); });
      head.insertBefore(t, head.querySelector('[data-done]'));
      setUnit(unit);
      new MutationObserver(unitSwitch).observe(title, { childList: true, characterData: true, subtree: true });
    }
    var show = /size/i.test(title.textContent);
    if (t.hidden === show) t.hidden = !show;
    if (show) hint();
  }
  function watch() {
    var cards = q('[data-gapcfg] [data-cards]');
    if (!cards) return false;
    new MutationObserver(tidy).observe(cards, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-checked'] });
    tidy(); unitSwitch();
    return true;
  }
  if (!watch()) document.addEventListener('DOMContentLoaded', watch);

  var SEL_KB = '[data-gapcfg] [data-sheet] input', vv = window.visualViewport;
  function kbFit() {
    var g = q('[data-gapcfg]');
    if (!g) return;
    var on = root.classList.contains('gapcfg-kb');
    g.style.height = on && vv ? vv.height + 'px' : '';
    g.style.top = on && vv ? vv.offsetTop + 'px' : '';
    if (on && document.activeElement && document.activeElement.scrollIntoView) document.activeElement.scrollIntoView({ block: 'nearest' });
  }
  document.addEventListener('focusin', function (e) {
    if (!e.target.matches || !e.target.matches(SEL_KB)) return;
    root.classList.add('gapcfg-kb'); kbFit(); setTimeout(kbFit, 350);
  });
  document.addEventListener('focusout', function (e) {
    if (!e.target.matches || !e.target.matches(SEL_KB)) return;
    setTimeout(function () {
      var a = document.activeElement;
      if (a && a.matches && a.matches(SEL_KB)) return;
      root.classList.remove('gapcfg-kb'); kbFit();
    }, 60);
  });
  if (vv) { vv.addEventListener('resize', kbFit); vv.addEventListener('scroll', kbFit); }

  /* (5) Border placement. "Inside size" keeps the chosen size and the border eats into the photo (the original behaviour);
     "Add around" grows the print by twice the border so the photo keeps its size: it picks the matching standard size
     or sets that custom size, by driving the configurator's own Size controls, and the price follows. */
  var BW = { mode: 'in', base: null, b: 0, prod: '', busy: false };
  function tabBy(re) { return [].filter.call(document.querySelectorAll('[data-gapcfg] .gapcfg__tab'), function (t) { var n = t.querySelector('b'); return n && re.test(n.textContent); })[0]; }
  function tabVal(re) { var t = tabBy(re), s = t && t.querySelector('small'); return s ? s.textContent : ''; }
  function curSize() { var m = SIZE.exec(tabVal(/size/i)); return m ? { w: +m[1], h: +m[2] } : null; }
  function curBorder() { var m = /^(\d+)\s*cm/.exec(tabVal(/^border$/i)); return m ? +m[1] : 0; }
  function lbl(s) { return String(Math.round(s.w * 10) / 10) + '×' + String(Math.round(s.h * 10) / 10); }
  function grow(s, b) { return { w: s.w + 2 * b, h: s.h + 2 * b }; }
  function setSize(s) {
    var st = tabBy(/size/i), bt = tabBy(/^border$/i);
    if (!st || !bt) return false;
    BW.busy = true;
    st.click();
    var want = lbl(s) + ' cm', ok = false;
    var card = [].filter.call(document.querySelectorAll('[data-gapcfg] [data-cards] .gapcfg__card'), function (c) { var n = c.querySelector('b'); return n && n.textContent.trim() === want && !c.disabled; })[0];
    if (card) { card.click(); ok = true; }
    else {
      var cc = [].filter.call(document.querySelectorAll('[data-gapcfg] [data-cards] .gapcfg__card'), function (c) { return c.textContent.indexOf('Custom size') === 0; })[0];
      if (cc) {
        cc.click();
        var w = q('[data-gapcfg] [data-cw]'), h = q('[data-gapcfg] [data-ch]'), u = q('[data-gapcfg] [data-cuse]');
        w.value = s.w; h.value = s.h; w.dispatchEvent(new Event('input', { bubbles: true }));
        if (u && !u.disabled) { u.click(); ok = true; }
      }
    }
    tabBy(/^border$/i).click();
    BW.busy = false;
    return ok;
  }
  function canGrow(s, b) { var g = grow(s, b); return g.w <= 100 && g.h <= 100; }
  function around(on) { var g = q('[data-gapcfg]'); if (g && g.hasAttribute('data-around') !== on) { if (on) g.setAttribute('data-around', ''); else g.removeAttribute('data-around'); } }
  function borderSwitch() {
    if (BW.busy) return;
    var sheet = q('[data-gapcfg] [data-sheet]'), title = q('[data-gapcfg] [data-sheettitle]'), c2 = q('[data-gapcfg] [data-cards2]');
    if (!sheet || !title || !c2) return;
    var prod = (q('[data-gapcfg] [data-title]') || {}).textContent || '', b = curBorder(), s = curSize();
    if (prod !== BW.prod) { BW.prod = prod; BW.mode = 'in'; BW.base = null; around(false); }
    if (BW.mode === 'out') {
      var exp = BW.base && grow(BW.base, BW.b);
      if (!s || !exp || lbl(s) !== lbl(exp)) { BW.mode = 'in'; BW.base = null; around(false); }
      else if (b !== BW.b) {
        var base = BW.base;
        if (!b || !canGrow(base, b)) { BW.mode = 'in'; BW.base = null; around(false); setTimeout(function () { setSize(base); }, 0); }
        else { BW.b = b; setTimeout(function () { if (!setSize(grow(base, b))) { BW.mode = 'in'; BW.base = null; around(false); setSize(base); } }, 0); }
        return;
      }
    }
    var el = sheet.querySelector('.gapcfg__bplace');
    var show = /border/i.test(title.textContent) && b > 0 && !!s;
    if (!show) { if (el && !el.hidden) el.hidden = true; return; }
    if (!el) {
      el = document.createElement('div'); el.className = 'gapcfg__bplace'; el.setAttribute('role', 'radiogroup'); el.setAttribute('aria-label', 'Border placement');
      el.innerHTML = '<button type="button" role="radio" data-m="in"></button><button type="button" role="radio" data-m="out"></button><p></p>';
      el.addEventListener('click', function (e) {
        var m = e.target.closest && e.target.closest('button'); m = m && m.getAttribute('data-m');
        if (!m || m === BW.mode) return;
        var bb = curBorder(), cs = curSize();
        if (m === 'out') {
          if (!cs || !canGrow(cs, bb)) return;
          BW.base = cs; BW.b = bb; BW.mode = 'out'; around(true);
          if (!setSize(grow(cs, bb))) { BW.mode = 'in'; BW.base = null; around(false); setSize(cs); }
        } else if (BW.base) { var base = BW.base; BW.mode = 'in'; BW.base = null; around(false); setSize(base); }
        borderSwitch();
      });
    }
    if (el.previousElementSibling !== c2) c2.insertAdjacentElement('afterend', el);
    var base = BW.mode === 'out' ? BW.base : s, g = grow(base, b), fits = canGrow(base, b);
    var bi = el.children[0], bo = el.children[1], note = el.children[2];
    var ti = 'Inside size · ' + lbl(base), to = 'Add around · ' + lbl(g);
    if (bi.textContent !== ti) bi.textContent = ti;
    if (bo.textContent !== to) bo.textContent = to;
    var ai = String(BW.mode === 'in'), ao = String(BW.mode === 'out');
    if (bi.getAttribute('aria-checked') !== ai) bi.setAttribute('aria-checked', ai);
    if (bo.getAttribute('aria-checked') !== ao) bo.setAttribute('aria-checked', ao);
    if (bo.disabled === fits) bo.disabled = !fits;
    var nt = fits ? '' : 'Add around is up to 100 cm per side.';
    if (note.textContent !== nt) note.textContent = nt;
    if (el.hidden) el.hidden = false;
  }
  var css2 = document.createElement('style');
  css2.textContent = '.gapcfg__bplace{display:flex;flex-wrap:wrap;gap:4px;margin-top:10px;background:#EFEBE6;border-radius:999px;padding:3px}'
    + '.gapcfg__bplace[hidden]{display:none}'
    + '.gapcfg__bplace button{flex:1;appearance:none;border:0;border-radius:999px;background:transparent;color:#333;font-family:inherit;font-weight:600;font-size:13px;line-height:1.2;padding:9px 4px;cursor:pointer}'
    + '.gapcfg__bplace button[aria-checked=true]{background:#C8401A;color:#fff}'
    + '.gapcfg__bplace button:disabled{opacity:.4;cursor:default}'
    + '[data-gapcfg] [data-price]{background:#FF8C3A;color:#1E1B18;border-radius:999px;padding:5px 14px}'
    + '[data-gapcfg]:has([data-pick]:not([hidden])) [data-price]{background:none;padding:0}'
    + '.gapcfg__wallbtn{background:#F5B82E!important;border-color:#F5B82E!important;color:#1E1B18!important}'
    + '@keyframes gapNudge{0%{box-shadow:0 0 0 0 rgba(245,184,46,.75);transform:scale(1)}40%{transform:scale(1.08)}100%{box-shadow:0 0 0 14px rgba(245,184,46,0);transform:scale(1)}}'
    + '.gapcfg__wallbtn.is-nudge{animation:gapNudge 1.1s ease-out 3}'
    + '@media (prefers-reduced-motion:reduce){.gapcfg__wallbtn.is-nudge{animation:none}}'
    + '.gapcfg .gapcfg__done.is-go{background:#0F8B8D;color:#fff;border-radius:999px;padding:8px 18px}'
    + '@keyframes gapGo{0%{box-shadow:0 0 0 0 rgba(15,139,141,.7);transform:scale(1)}40%{transform:scale(1.1)}100%{box-shadow:0 0 0 14px rgba(15,139,141,0);transform:scale(1)}}'
    + '.gapcfg .gapcfg__done.is-go.is-pulse{animation:gapGo 1.1s ease-out 3}'
    + '@media (prefers-reduced-motion:reduce){.gapcfg .gapcfg__done.is-go.is-pulse{animation:none}}'
    + '.gapcfg__bplace p{flex-basis:100%;margin:0;padding:0 12px;font-size:12px;opacity:.7}.gapcfg__bplace p:empty{display:none}';
  document.head.appendChild(css2);
  /* (6) On wall nudge: once the photo is uploaded and the choices are closed (the last step before Add to cart), the
     On wall button pulses three times, once per product. */
  var nudged = '';
  function nudge() {
    var g = q('[data-gapcfg]'), w = q('.gapcfg__wallbtn'), st = q('[data-gapcfg] [data-status]');
    if (!g || !w || !st) return;
    var ready = /uploaded/i.test(st.textContent) && (window.innerWidth >= 900 || !g.classList.contains('is-sheet'));
    if (!ready || nudged === BW.prod) return;
    nudged = BW.prod;
    w.classList.remove('is-nudge'); void w.offsetWidth; w.classList.add('is-nudge');
  }
  /* (7) Done cue (phones): while an option sheet is open the Add to cart row is hidden, so once the photo is in and the
     order can be added, Done turns teal, pulses three times (once per product) and stays teal. */
  var cued = '';
  function doneCue() {
    var g = q('[data-gapcfg]'), d = q('[data-gapcfg] [data-done]'), a = q('[data-gapcfg] [data-add]');
    if (!g || !d || !a) return;
    var go = window.innerWidth < 900 && g.classList.contains('is-sheet') && /^Add to cart/.test(a.textContent);
    if (d.classList.contains('is-go') !== go) d.classList.toggle('is-go', go);
    if (!go || cued === BW.prod) return;
    cued = BW.prod;
    d.classList.remove('is-pulse'); void d.offsetWidth; d.classList.add('is-pulse');
  }
  function watchBorder() {
    var g = q('[data-gapcfg]');
    if (!g) return false;
    new MutationObserver(function () { borderSwitch(); nudge(); doneCue(); }).observe(g, { childList: true, subtree: true, characterData: true });
    borderSwitch();
    return true;
  }
  if (!watchBorder()) document.addEventListener('DOMContentLoaded', watchBorder);
})();
